import { render, staticRenderFns } from "./ClientWidgets.vue?vue&type=template&id=4fad1677&scoped=true&"
import script from "./ClientWidgets.vue?vue&type=script&lang=js&"
export * from "./ClientWidgets.vue?vue&type=script&lang=js&"
import style0 from "./ClientWidgets.vue?vue&type=style&index=0&id=4fad1677&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fad1677",
  null
  
)

export default component.exports